
import * as _ from 'lodash';

const initialState = {
  toast:{
    showToast : false,
    color: "primary",
    outlined: true,
    timeout: 1700,
    text: ""
  }
}

export const toaster = {
  state: initialState,
  actions: {
    changeToast({commit},payload){
      commit('changeToastSuccess', payload)
    }
  },
  getters: {
    toast: state => state.toast
  },
  mutations: {
    changeToastSuccess(state, toast) {
      state.toast = toast;
    }
  },   
};

export default toaster;
